<template>
    <div style="width: 40%;height: 100px;text-align: center;" :style="{
      '--radio-button-color': $store.getters.getButtonColor,
      '--star-svg-height': `${starHeight}px`
      }">
        <ul class="rating-card__list">
            <li class="rating-card__list__item" v-bind:class="{'-select': model.crowded}"
                v-for="(model, index) in question.answers"
                v-on:click="selectStar(model, index)" v-bind:key="index">
                <label>



                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 500 500"
                         style="enable-background:new 0 0 500 500;" xml:space="preserve"
                         v-bind:class="{'bounce': model.bounced}" class="star-ico"
                    >
<path class="st0" d="M283.5,28.3c-7.9,8.2-16.4,16-23.7,24.7c-13.3,15.8-24,33.1-22.5,54.8c0.5,7.3,3.2,15,6.8,21.4  c4.8,8.6,12.9,12.9,23.3,10.3c10.5-2.6,14.8-10.4,15.5-20.3c0.4-5.9-0.5-11.9-0.8-17.9c34.1,20.1,49,54.4,40.4,92.6  c-2.5,11.2-5.7,22.3-6.9,33.6c-1.7,16.3,5.3,26.6,19.3,31.1c10.9,3.5,22.8-1.7,30.8-14.3c3.6-5.7,6-12.1,9.6-19.4  c20,17.7,33,39.4,40.6,64c9.5,30.7,8.8,61.8,0.4,92.8c-0.7,2.7-2.4,6-4.6,7.5c-14.5,9.8-29.3,19.2-43.1,28.1  c-1.2-22.1-2.3-44-3.4-65.8c-0.9-0.1-1.7-0.1-2.6-0.2c-7.7,22.2-15.4,44.3-23.1,66.5c-1,0-2,0-3.1,0c-6.3-32.2-29.2-51-53.7-68.7  c-20.8-15.1-39.7-31.9-48.8-57.5c-1.3,0.7-2.6,1.4-3.9,2.1c4.7,13.1,8.4,26.7,14.2,39.3c7.2,15.6,17.7,29.7,24,45.6  c5.2,13.1,8.8,27.8,8.6,41.8c-0.2,20.5-13.3,33.8-32.9,39.3c-20.5,5.7-37.6-0.8-51.4-16.6c-2.4-2.8-4.4-6-7.9-10.8  c0,7.3,0,12.6,0,19.5c-3.9-2.4-6.4-3.8-8.7-5.5c-23-16.4-46.3-32.6-68.9-49.6c-4.7-3.5-9.3-9.4-10.7-15  c-13.6-54.4-5.9-104.6,31.2-148.5c2.2-2.6,4.9-4.9,7.4-7.2c0.8-0.7,1.8-1,3.5-1.9c0,10.3-0.1,20,0,29.7c0,5.4-0.2,10.8,0.6,16  c2.1,14.2,12.3,23.5,24.3,22.8c11.4-0.6,20.2-10.7,19.1-25.5c-1.6-21.3-6.2-42.3-7.8-63.6c-1.7-23.1-3.6-46.6-1.5-69.6  c3.4-38,24.2-66.7,57.2-85c16.4-9.1,35.1-14.3,52.7-21.2C282.9,27.7,283.5,28.3,283.5,28.3z"/>
</svg>

                    <div style="font-weight:200">{{ model.title }}&nbsp;&nbsp;</div>
                </label>
            </li>
        </ul>


        <label v-for="model in question.answers" v-bind:key="model.uid">
            <input style="display:none;" type="radio"
                   v-bind:id="'star'+ model.uid"
                   v-on:click="setRadio(model.uid)"
                   :value="model.uid"
                   :name="question.uid"
                   :checked="model.selected"
            />
        </label>

        <transition name="fade">
            <comment v-show="showComment" :placeholder="commentPlaceholder" :name="commentName"></comment>
        </transition>
        <input type="hidden" class="answerSelected" data-question="question.uid" v-model="answerSelected">
    </div>
</template>

<script>
    import Vue from 'vue';
    import Comment from './Comment';
    import Star from 'vue-rate-it/glyphs/star';


    export default {
        name: 'fire',
        props: ['question'],
        data() {
            return {
                answerSelected: false,
                showComment: false,
                commentPlaceholder: false,
                commentName: false,
                radioButtonCheckedPath: false,
                radioButtonUncheckedPath: false,
                thumbsUp: '',
                starHeight: 30,
                stars: [{
                    value: 1,
                    text: '',
                    gradientFrom: '#FC8885',
                    gradientTo: '#FB7C7F',
                    selected: false,
                },
                    {
                        value: 2,
                        text: '',
                        gradientFrom: '#FB7A7E',
                        gradientTo: '#F96A74',
                        selected: false,
                    },
                    {
                        value: 4,
                        text: '',
                        gradientFrom: '#F8636F',
                        gradientTo: '#F75062',
                        selected: false,
                    },
                    {
                        value: 5,
                        text: '',
                        gradientFrom: '#F75165',
                        gradientTo: '#F6415A',
                        selected: false,
                    }
                ]
            }
        },
        created() {
            // register the icon
            this.star = Star
        },
        mounted() {
            this.radioButtonCheckedPath = this.$store.getters.getRadioButtonCheckedPath;
            this.radioButtonUncheckedPath = this.$store.getters.getRadioButtonUnCheckedPath;
        },
        methods: {
            setRadio: function (uid) {
                this.showComment = false;
                this.commentPlaceholder = false;
                this.commentName = false;

                this.$emit("inputClick", uid);

                this.question.answers.forEach((item, index) => {
                    if (item.uid === uid) {
                        item.selected = true;
                        if (item.is_allow_comment) {
                            this.showComment = true;
                            this.commentPlaceholder = item.comment_placeholder;
                            this.commentName = 'comment_' + this.question.uid;
                        }
                        Vue.set(this.question.answers, index, item);
                    } else {
                        item.selected = false;
                        Vue.set(this.question.answers, index, item);
                    }

                    this.$emit("checkDependency", uid);
                });
            },
            onRatingSelected(e) {
                this.setRadio(e);
            },
            resetStars() {
                this.question.answers.forEach(model => model.crowded = false)
            },
            selectStar(model, index) {
                console.log('select');
                this.resetStars()
                let i = 0;
                this.setRadio(model.uid);
                const f = () => {
                    if (i <= index) {
                        this.question.answers[i].crowded = true;
                        i++;
                        setTimeout(f, 100)
                    }
                    model.bounced = true;
                }
                model.bounced = false;
                setTimeout(f, 100)
            },
        },
        components: {
            Comment
        }
    }
</script>

<style>

    :root {
        --star-svg-height: '100px'
    }

    .st0{
        fill:#FEC210;
    }

    @keyframes bounce {
        0% {
            width: 32px;
            height: 56px;
        }
        25% {
            width: 34px;
            height: 58px;
        }
        50% {
            width: 36px;
            height: 59px;
        }
        100% {
            width: 38px;
            height: 60px;
        }
    }

    .bounce {
        animation-name: bounce;
        animation-duration: 0.2s;
    }
</style>
<style lang="scss">
    .rating-card__list {
        margin: 0;
        padding: 0;
        list-style-type: none;
        display: flex;
        justify-content: space-between;
        flex-basis: auto;

        &__item {
            flex-basis: 25%;
            flex-grow: 1;
            font-size: 12px;
            padding-left: 10px;

            .-checked & {
                font-weight: 200;
            }

            input {
                display: none;
            }

            input:checked + label {
                font-weight: 500;
            }

            svg {
                width: var(--star-svg-height);
                height: 54px;

                &:hover {
                    cursor: pointer;
                }

                path {
                    fill: #e6e7ea;
                }
            }

            &.-select {
                svg {
                    path {
                        fill: var(--radio-button-color)
                    }
                }
            }
        }
    }
</style>